import React from 'react';
import { SessionType } from '../types';

interface SessionIndicatorProps {
  sessionType: SessionType;
  pomodoroCount: number;
  isCompleted: boolean;
}

const SessionIndicator: React.FC<SessionIndicatorProps> = ({ 
  sessionType, 
  pomodoroCount,
  isCompleted 
}) => {
  const getSessionInfo = () => {
    switch (sessionType) {
      case SessionType.WORK:
        return {
          title: 'Focus Session',
          emoji: '🍅',
          color: 'text-primary bg-primary/10 border-primary/30',
          description: `Pomodoro ${pomodoroCount} of 4`
        };
      case SessionType.SHORT_BREAK:
        return {
          title: 'Short Break',
          emoji: '☕',
          color: 'text-accent bg-accent/20 border-accent/40',
          description: 'Time to rest'
        };
      case SessionType.LONG_BREAK:
        return {
          title: 'Long Break',
          emoji: '🌟',
          color: 'text-primary bg-accent/10 border-accent/30',
          description: 'Well deserved break!'
        };
    }
  };

  const sessionInfo = getSessionInfo();

  return (
    <div className="flex flex-col items-center space-y-4">
      {/* Session type card */}
      <div 
        className={`
          flex items-center space-x-3 px-6 py-3 rounded-lg border-2 
          transition-all duration-300 ${sessionInfo.color}
          ${isCompleted ? 'ring-2 ring-green-400 ring-opacity-50' : ''}
        `}
      >
        <span className="text-2xl">{sessionInfo.emoji}</span>
        <div className="text-center">
          <h2 className="text-xl font-bold">{sessionInfo.title}</h2>
          <p className="text-sm opacity-75">{sessionInfo.description}</p>
        </div>
      </div>

      {/* Session completion message */}
      {isCompleted && (
        <div className="flex items-center space-x-2 text-primary font-medium animate-bounce">
          <span className="text-lg">✨</span>
          <span>Session Complete!</span>
          <span className="text-lg">✨</span>
        </div>
      )}

      {/* Pomodoro progress dots (only show during work sessions) */}
      {sessionType === SessionType.WORK && (
        <div className="flex space-x-2">
          {[1, 2, 3, 4].map((num) => (
            <div
              key={num}
              className={`
                w-3 h-3 rounded-full transition-colors duration-300
                ${num <= pomodoroCount 
                  ? 'bg-primary' 
                  : 'bg-text/20'
                }
              `}
              title={`Pomodoro ${num}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SessionIndicator; 